import { useTranslation } from 'react-i18next'

/**
 * Placeholder body used by every route until the real feature lands.
 * Keeps the routing + auth + nav wired so we can ship route-by-route
 * instead of needing the whole epic before anything is testable.
 */
export function StubScreen({ heading }: { heading: string }) {
  const { t } = useTranslation()
  return (
    <section aria-labelledby="stub-heading" className="space-y-2">
      <h1 id="stub-heading" className="text-2xl font-semibold">
        {heading}
      </h1>
      <p className="text-sm text-zinc-500 dark:text-zinc-400">
        {t('stub.heading')} — {t('stub.body')}
      </p>
    </section>
  )
}
